var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "li",
    {
      staticClass: "courseware-unit-item",
    },
    [
      _c("courseware-tile", {
        attrs: {
          tag: "div",
          color: _vm.color,
          title: _vm.title,
          descriptionLink: _vm.url,
          descriptionTitle: _vm.$gettext("Lernmaterial öffnen"),
          displayProgress: _vm.inCourseContext,
          progress: _vm.progress,
          imageUrl: _vm.imageUrl,
          handle: _vm.handle,
          handleId: "unit-handle-" + _vm.unit.id,
        },
        on: {
          "handle-keydown": function handleKeydown($event) {
            return _vm.$emit("unit-keydown", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "image-overlay-with-action-menu",
            fn: function fn() {
              return [
                _c("studip-action-menu", {
                  staticClass: "cw-unit-action-menu",
                  attrs: {
                    items: _vm.menuItems,
                    context: _vm.title,
                    collapseAt: 0,
                  },
                  on: {
                    showDelete: _vm.openDeleteDialog,
                    showExport: _vm.openExportDialog,
                    showProgress: _vm.openProgressDialog,
                    showSettings: _vm.openSettingsDialog,
                    showLayout: _vm.openLayoutDialog,
                    copyUnit: _vm.copy,
                    showFeedbackCreate: _vm.openFeedbackCreateDialog,
                    showFeedback: _vm.openFeedbackDialog,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "description",
            fn: function fn() {
              return [
                _vm._v(
                  "\n            " + _vm._s(_vm.description) + "\n        "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function fn() {
              return [
                _vm.hasFeedbackElement
                  ? [
                      _vm.hasFeedbackEntries
                        ? _c("studip-five-stars", {
                            attrs: {
                              amount: _vm.feedbackAverage,
                              size: 16,
                              title: _vm.$gettextInterpolate(
                                _vm.$gettext(
                                  "Lernmaterial wurde mit %{avg} Sternen bewertet"
                                ),
                                {
                                  avg: _vm.feedbackAverage,
                                }
                              ),
                            },
                          })
                        : _c("studip-five-stars", {
                            attrs: {
                              amount: 5,
                              size: 16,
                              role: "inactive",
                              title: _vm.$gettext(
                                "Lernmaterial wurde noch nicht bewertet"
                              ),
                            },
                          }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.certificate
                  ? [
                      _c("studip-icon", {
                        attrs: {
                          shape: "medal",
                          size: 16,
                          role: "info_alt",
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Lernmaterial löschen"),
              question: _vm.$gettextInterpolate(
                _vm.$gettext(
                  "Möchten Sie das Lernmaterial %{ unitTitle } wirklich löschen?"
                ),
                {
                  unitTitle: _vm.title,
                },
                true
              ),
              height: "200",
            },
            on: {
              confirm: _vm.executeDelete,
              close: _vm.closeDeleteDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showProgressDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.userIsTeacher
                ? _vm.$gettext("Fortschritt aller Teilnehmenden")
                : _vm.$gettext("Mein Fortschritt"),
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
              width: "800",
              height: "600",
            },
            on: {
              close: _vm.closeProgressDialog,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c("courseware-unit-progress", {
                        attrs: {
                          progressData: _vm.progresses,
                          unitId: _vm.unit.id,
                          rootId: parseInt(_vm.unitElement.id),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3003099453
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportDialog
        ? _c("courseware-unit-item-dialog-export", {
            attrs: {
              unit: _vm.unit,
            },
            on: {
              close: function close($event) {
                _vm.showExportDialog = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSettingsDialog
        ? _c("courseware-unit-item-dialog-settings", {
            attrs: {
              unit: _vm.unit,
            },
            on: {
              close: _vm.closeSettingsDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLayoutDialog
        ? _c("courseware-unit-item-dialog-layout", {
            attrs: {
              unit: _vm.unit,
              unitElement: _vm.unitElement,
            },
            on: {
              close: _vm.closeLayoutDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFeedbackDialog
        ? _c("feedback-dialog", {
            attrs: {
              feedbackElementId: parseInt(_vm.feedbackElementId),
              currentUser: _vm.currentUser,
            },
            on: {
              deleted: function deleted($event) {
                return _vm.loadUnit({
                  id: _vm.unit.id,
                })
              },
              close: _vm.closeFeedbackDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFeedbackCreateDialog
        ? _c("feedback-create-dialog", {
            attrs: {
              defaultQuestion: _vm.$gettext("Bewerten Sie das Lernmaterial"),
              rangeType: "courseware-units",
              rangeId: _vm.unit.id,
            },
            on: {
              created: function created($event) {
                return _vm.loadUnit({
                  id: _vm.unit.id,
                })
              },
              close: _vm.closeFeedbackCreateDialog,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }